import { parseServerDate } from "@persolog/utils";

/**
 * Formats a backend timestamp as date + time for the support views.
 *
 * Backend datetime strings are UTC without a zone marker, so `new Date()` would read them as
 * viewer-local and shift the rendered time — hence `parseServerDate`. The output is rendered in
 * Europe/Berlin, which is the timezone the support team works in and the one the trainer-facing
 * timestamps already use.
 *
 * Extracted from TrainersTable so the participant activity timeline shows timestamps the same way
 * instead of growing a fourth local copy of this logic.
 */
export function formatDateTime(
    value: string | Date,
    { locale = "de-DE", timeZone = "Europe/Berlin", separator = " " } = {},
): string {
    const date = value instanceof Date ? value : parseServerDate(value);

    const datePart = new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeZone }).format(date);
    const timePart = new Intl.DateTimeFormat(locale, { timeStyle: "short", timeZone }).format(date);

    return `${datePart}${separator}${timePart}`;
}
